// Real facts owner-confirmed 2026-07-09/10. Privacy, Terms and online-order
// refund rules owner-approved 2026-10-23 for the Cashfree website review.
const CONTACT =
  "bindalscreations@gmail.com · WhatsApp +91 98108 73280 · 58 Sihani Gate Market, Near Durga Bhabhi Chowk, Ghaziabad, Uttar Pradesh 201001";
// Named contact for data requests (Digital Personal Data Protection Act, 2023).
const DATA_CONTACT_NAME = "Pooja Bindal";

export const SHIPPING = [
  {
    heading: "Dispatch & delivery",
    body: [
      "We dispatch orders within 2 working days.",
      "Delivery typically takes 5–7 days after dispatch.",
    ],
  },
  {
    heading: "Shipping charges",
    body: [
      "Shipping is free on orders of ₹5,000 and above. Below that, the courier charge for your pincode is shown at checkout before you pay.",
    ],
  },
];

export const RETURNS = [
  {
    heading: "Returns",
    body: [
      "Online orders can be returned if the item arrives damaged or wrong (reported within 48 hours of delivery), or if you change your mind (within 7 days of delivery), as described below. We do not send replacement parcels: if you want a different piece, you can place a new order, or exchange in store (see Exchanges).",
      "Change of mind: you can return an item within 7 days of delivery if it is unused, with tags attached and in its original packaging. You can send it back at your own cost or bring it to our shop. The product price is refunded; the shipping charge is not refunded. If a returned piece fails our check, it is sent back to you at your cost.",
      "Refunds are made only after the item reaches us and passes our check, to the original payment method within 5–7 working days, or as instant store credit if you choose.",
      "To start a return, message us on WhatsApp at +91 98108 73280 or email bindalscreations@gmail.com.",
    ],
  },
  {
    heading: "Cancelling an online order",
    body: [
      "You can cancel an online order any time before it is dispatched by messaging us on WhatsApp at +91 98108 73280 or emailing bindalscreations@gmail.com.",
      "Cancelled orders are refunded in full, to the original payment method within 5–7 working days, or as instant store credit if you choose.",
      "Once an order has been dispatched it can no longer be cancelled.",
    ],
  },
  {
    heading: "Custom orders",
    body: [
      "Made-to-order pieces are made for you and cannot be returned or exchanged. See \"Custom orders\" in our Terms of Service for cancellations and alterations.",
    ],
  },
  {
    heading: "Damaged or wrong item",
    body: [
      "If your online order arrives damaged or you receive the wrong item, tell us within 48 hours of delivery on WhatsApp or by email, with photos of the item and packaging.",
      "We arrange pickup at our cost. If the whole order comes back, we refund the full amount including shipping; otherwise we refund the value of the returned items. The refund is made after the item reaches us and passes our check, to the original payment method within 5–7 working days, or as instant store credit if you choose.",
    ],
  },
  {
    heading: "Unavailable items and returned parcels",
    body: [
      "If an item you paid for turns out to be unavailable, it is refunded to the original payment method, or as instant store credit if you choose.",
      "If a prepaid parcel is refused or undeliverable and returns to us, we refund the item value; the shipping charge is not refundable.",
    ],
  },
  {
    heading: "Exchanges",
    body: [
      "Exchanges are accepted within 7 days of purchase, in-store only, with the original bill. For online orders, the 7 days count from the day of delivery.",
      "The garment must be unworn, unwashed and in original condition with tags intact.",
    ],
  },
  {
    heading: "Exchange conditions",
    body: [
      "Exchange or store credit is limited to the amount paid on the original bill.",
      "Colours may vary slightly from what appears on screen and are not guaranteed.",
      "For in-store purchases, please report any damage within 24 hours of purchase.",
    ],
  },
  {
    heading: "How to exchange",
    body: [
      "Visit us at 58 Sihani Gate Market, Near Durga Bhabhi Chowk, Ghaziabad, Uttar Pradesh 201001 with the garment and your proof of purchase. Message us on WhatsApp at +91 98108 73280 before visiting if you have any questions.",
    ],
  },
];

export const PRIVACY = [
  {
    heading: "Who we are",
    body: [
      "This website is run by Bindals Creation (Prop. Pooja Bindal), a sole proprietorship, 58 Sihani Gate Market, Near Durga Bhabhi Chowk, Ghaziabad, Uttar Pradesh 201001 (GSTIN 09ABVPB4203A1Z4). This policy explains what personal information we collect and how we use it.",
    ],
  },
  {
    heading: "Information we collect",
    body: [
      "When you place an order or contact us: your name, mobile number, email address and delivery address.",
      "When you create an account: your email address, which we use to sign you in with a one-time link.",
      "Your cart and wishlist, so they are saved between visits.",
      "Our hosting providers keep basic technical logs (such as IP address and browser type) for security.",
      "We do not see or store your card, UPI or bank details. Payments are processed by our payment partner, Cashfree Payments, under its own security standards.",
    ],
  },
  {
    heading: "How we use your information",
    body: [
      "To confirm, pack, deliver and support your order, and to issue your bill.",
      "To contact you about your order on WhatsApp, phone or email.",
      "Only with your consent, to tell you about new collections and offers. You can opt out at any time by messaging us.",
    ],
  },
  {
    heading: "Who we share it with",
    body: [
      "Courier partners (booked through Shiprocket): your name, phone number and delivery address, so they can deliver your parcel.",
      "Our payment partner, Cashfree Payments: the details needed to process your payment.",
      "Our website and database providers, which store data on our behalf.",
      "Government authorities, where the law requires it.",
      "We never sell your personal information.",
    ],
  },
  {
    heading: "How long we keep it",
    body: [
      "Order and billing records are kept for as long as tax and accounting laws require.",
      "Your account, cart and wishlist are kept until you ask us to delete them.",
    ],
  },
  {
    heading: "Your rights and contact",
    body: [
      "You can ask to see, correct or delete your personal information, or withdraw consent for marketing messages, at any time.",
      `For any privacy request or concern, contact ${DATA_CONTACT_NAME}, Proprietor: ${CONTACT}.`,
      "We may update this policy from time to time; the current version is always on this page. Effective from 23 October 2026.",
    ],
  },
];

export const TERMS = [
  {
    heading: "About us",
    body: [
      "This website is operated by Bindals Creation (Prop. Pooja Bindal), a sole proprietorship, 58 Sihani Gate Market, Near Durga Bhabhi Chowk, Ghaziabad, Uttar Pradesh 201001 (GSTIN 09ABVPB4203A1Z4). By using this website or placing an order, you agree to these terms.",
    ],
  },
  {
    heading: "Products and prices",
    body: [
      "We try to show colours and details accurately, but colours can look slightly different on screens, and handwork can vary a little from piece to piece.",
      "Prices are in Indian Rupees and are final. No GST is charged separately: we are registered under the GST composition scheme and issue a Bill of Supply.",
      "If a price or listing is wrong, we will contact you before processing your order, and you may cancel for a full refund.",
    ],
  },
  {
    heading: "Orders and payment",
    body: [
      "An order is confirmed once we receive your payment.",
      "We may decline or cancel an order if an item is out of stock, the delivery address is outside our delivery area, or we suspect fraud. Any amount paid is refunded in full, to the original payment method or as instant store credit if you choose.",
      "Payments are processed securely by Cashfree Payments (UPI, cards and net banking). We do not store your payment details.",
    ],
  },
  {
    heading: "Delivery",
    body: [
      "Dispatch times, delivery times and shipping charges are set out in our Shipping Policy.",
    ],
  },
  {
    heading: "Cancellations, exchanges and refunds",
    body: [
      "Online orders can be cancelled before dispatch for a full refund, to the original payment method within 5–7 working days or as instant store credit if you choose. If a prepaid parcel is refused or undeliverable and returns to us, we refund the item value; the shipping charge is not refundable. After delivery, items can be returned if damaged or wrong (reported within 48 hours of delivery) or, if unused and in original packaging with tags attached, within 7 days of delivery for a change of mind; refunds are made after the returned item reaches us and passes our check. Exchanges follow our Returns & Exchange Policy.",
    ],
  },
  {
    heading: "Custom orders",
    body: [
      "For made-to-order pieces we send a quote with the price and a ready-by date. We make the piece as close to your photos as we can; fabric, handwork and colour may differ slightly, and we tell you about any change in the quote. The quote is the final price; any budget you share only helps us plan. The minimum order is ₹3,000, and rush orders (under 2 weeks) carry an extra charge shown in the quote.",
      "Work starts once you pay 50% of the quote as an advance. The balance is due when the piece is ready, before collection or dispatch.",
      "Because work starts straight away, the advance is not refundable. If you contact us by phone or WhatsApp within 1 day of paying, we will tell you whether a refund is still possible; this is at our discretion. If we cancel a custom order, we refund everything you paid.",
      "One fitting and free alterations are offered at our shop. Pieces delivered to you cannot be sent back for alterations, but you are welcome to bring them to the shop.",
      "Custom pieces cannot be returned or exchanged. Delivery is charged at the fee shown in the quote.",
    ],
  },
  {
    heading: "Use of this website",
    body: [
      "Do not misuse this website, including scraping, fraud or attempts to break its security.",
      "Photos and text on this website belong to Bindals Creation and may not be reused without our permission.",
    ],
  },
  {
    heading: "Governing law and contact",
    body: [
      "These terms are governed by the laws of India, and courts in Ghaziabad, Uttar Pradesh have jurisdiction.",
      `Questions about these terms: ${CONTACT}.`,
    ],
  },
];
